var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgressBullet = function SvgProgressBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32D583",
    d: "M12 2.04c5.937 0 10.75 4.812 10.75 10.75 0 5.936-4.813 10.75-10.75 10.75S1.25 18.725 1.25 12.79C1.25 6.851 6.063 2.04 12 2.04m4.676 7.012a1 1 0 0 0-1.413.061l-4.794 5.23-1.762-1.761a1 1 0 1 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.444-.031l5.5-6a1 1 0 0 0-.061-1.413"
  })));
};
export default SvgProgressBullet;